module.exports = __webpack_public_path__ + "img/tl.8c6b9fb5.png";